'use strict';

(function () {
  'use strict';

  angular.module('vnext').component('msPrintButton', {
    restrict: 'EA',
    templateUrl: 'sleep/templates/sleep-print-button.html',
    controller: PrintButtonCtrl,
    controllerAs: 'vm',
    bindToController: true,
    bindings: {
      template: '@'
    }
  });
  PrintButtonCtrl.$inject = ['$http', '$templateCache', '$compile', '$rootScope', '$timeout', 'NotifyingSvc'];

  function PrintButtonCtrl($http, $templateCache, $compile, $rootScope, $timeout, NotifyingSvc) {
    var vm = this;
    // Print page is a simple HTML wrapper template that contains our styles and is set up to be filled with simple printable content
    var printPage = null;
    // This is the number of load events that must occur before the page can be considered "Ready"
    var loadEventCount = void 0;
    // This is the template that will be loaded into print.html and printed
    var template = void 0;
    vm.print = printTemplate;

    ///////////////////////////////
    vm.$onInit = function () {
      // We need to load the wrapper template in advance, because the window open needs to happen on the user's click to avoid ad-blocking
      $http.get('/print').then(function (p) {
        return printPage = p.data;
      });
      loadEventCount = vm.loadEventCount || 3;
      template = vm.template || 'sleep/templates/print.html';
    };

    function printTemplate() {
      // Using a new "print" window to compile what we want printed
      var w = window.open();
      w.document.write(printPage);
      var main = w.document.getElementById('main');
      // Passed template needs to be in the cache - we don't load it
      $compile($templateCache.get(template))($rootScope.$new(), function (ele) {
        // This counter keeps track of the number of completed load events
        // We need to wait until ALL loads have happened before we can attempt to print
        var eventCount = 0;
        NotifyingSvc.subscribe(NotifyingSvc.EVENTS.PRINT_HTTP_COMPLETE, function () {
          eventCount++;
          if (eventCount >= loadEventCount) {
            main.innerHTML = ele.html();
            // This small timeout is necessary for some reason - some browsers need a second to render
            // I couldn't find anything to hook into that would resolve this
            // In testing this worked at as little as 10ms, so 150 to be safe
            $timeout(function () {
              w.document.close();
              w.focus();
              w.print();
              w.close();
            }, 150);
          }
        });
      });
    }
  }
})();